import {
  NAVIGATIONFEATUREFLAGS,
  NAVIGATIONPERMISSIONS,
  NavigationKey,
} from "@/constants/navigation-permissions";
import { usePermissions } from "./use-permissions";
import { usePlanFeatures } from "./use-plan-features";

export function useNavigationPermissions() {
  const { hasAnyPermission } = usePermissions();
  const { hasFeature } = usePlanFeatures();

  const canViewNavItem = (navKey?: NavigationKey): boolean => {
    if (!navKey) {
      return true;
    }

    // Special case: widgets (integrations) require either chat or email channels
    if (navKey === "widgets") {
      return (
        hasFeature("chat_channels" as App.Enums.PlanFeatureCodeEnum) ||
        hasFeature("email_channels" as App.Enums.PlanFeatureCodeEnum)
      );
    }

    // Special case: communications require either chat or email channels
    if (navKey === "communications") {
      return (
        hasFeature("chat_channels" as App.Enums.PlanFeatureCodeEnum) ||
        hasFeature("email_channels" as App.Enums.PlanFeatureCodeEnum)
      );
    }

    // Check feature flags first
    const requiredFeature = NAVIGATIONFEATUREFLAGS[navKey as keyof typeof NAVIGATIONFEATUREFLAGS];
    if (requiredFeature && !hasFeature(requiredFeature)) {
      return false;
    }

    // Type assertion to handle the string key lookup
    const requiredPermissions = NAVIGATIONPERMISSIONS[navKey as keyof typeof NAVIGATIONPERMISSIONS];

    // If no permissions are required or key doesn't exist, allow access
    if (!requiredPermissions || requiredPermissions.length === 0) {
      return true;
    }

    // Check if user has any of the required permissions
    return hasAnyPermission([...requiredPermissions] as App.Enums.PermissionEnum[]);
  };

  return {
    canViewNavItem,
  };
}
